import gql from 'graphql-tag'
import client from '@stores/apollo'

export default function confirmHealthCheck({
  id,
  checkedIn,
  followUpResponse,
}: {
  id: string | undefined
  checkedIn: boolean
  followUpResponse: boolean
}) {
  return client.gql.mutate({
    mutation,
    variables: { input: { id, passedHealthCheck: true, checkedIn: checkedIn, followUpResponse } },
  })
}

const mutation = gql`
  mutation updateBooking($input: UpdateBookingInput!) {
    updateBooking(input: $input) {
      booking {
        id
        space {
          id
        }
        employee {
          id
        }
        startDate
        endDate
        checkedIn
        passedHealthCheck
      }
    }
  }
`
